import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteExpenseCategoryService } from '@/services/expenseCategories'
import { expenseCategoriesQueryKey } from './useExpenseCategories'

export const useDeleteExpenseCategory = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (categoryId: number) => deleteExpenseCategoryService(agendaId, categoryId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: expenseCategoriesQueryKey(agendaId) })
    },
  })
}
